export default __webpack_public_path__ + "static/media/ArrowDownFilled.f0c9fa09.svg";